import { useIntl } from '@mfw/components';

import { useOrganizationContext } from '../../context';
import messages from './messages';

/**
 * The selected organization's name as it appears in "<Org> Home" /
 * "<Org> Schedule" titles (sidebar rows and page titles alike). The one
 * place that decides what those read when the name is missing: react-intl
 * would otherwise print the raw `{orgName} Home`.
 */
export default function useOrgDisplayName() {
  const { formatMessage } = useIntl();
  const { currentOrganization } = useOrganizationContext();
  const name = currentOrganization?.name?.trim();

  return name || formatMessage(messages.organizationFallbackName);
}
